module.exports = __webpack_public_path__ + "static/media/plasticman.00d72a62.jpeg";